import React from 'react';
import { IProps } from './types';
import OTPVerificationForm from 'components/OTPVerificationForm';

const otpVerification : React.FC<IProps> = (props) => {
  return (
    <>
      <OTPVerificationForm
        memberId={props.memberId}
        otpInfo={props.otpInfo}
        getOTPTime={props.getOTPTime}
        UICode={props.UICode}
        onUnavailableAuth={props.onGoFillInMember}
        onGoBack={props.onGoBack}
        onSubmit={props.onVerifyOTP}
        onResentOTP={props.onResentOTP}
        memberProfile={props.memberProfile}
      />
    </>
  );
};

export default otpVerification;
